import sdl from '@jds/react-generated-sdl/JDSFooter';
import type { JDSFooterProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, FooterProps } from '../logic';

const Component = (props: FooterProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { ariaLabel = 'Footer', custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { ariaLabel, ...rest },
    'JDSFooter',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Footer = withLogic(Component) as React.FC<FooterProps> & {
  slotName?: string;
};

Footer.displayName = 'Footer';
Footer.slotName = 'jds_footer';

export { Footer, type JDSFooterProps };
